module.exports = __webpack_public_path__ + "media/assets/fonts/RobotoCondensed-Italic-7d70998915d35a40e9fbe3179bc7a7c4.ttf";